import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import type { HazardReportIntake, HazardReportRecord, HazardReportScope, HazardReportStatus } from './repository';

const labels: Record<HazardReportStatus, string> = {
  received: '접수', acknowledged: '확인 중', 'improvement-linked': '개선 조치 중',
  'violation-linked': '위반사항 처리 중', resolved: '완료', rejected: '반려',
};

export function HazardOwnReports({ intake, scope }: { intake: HazardReportIntake | null; scope: HazardReportScope }) {
  const [items, setItems] = useState<HazardReportRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const scopeKey = JSON.stringify(scope);
  useEffect(() => {
    let active = true;
    setItems([]);
    setError('');
    if (!intake) return;
    if (intake.status !== 'ready') { setLoading(false); setError(intake.reason); return; }
    setLoading(true);
    void intake.repository.listOwn(JSON.parse(scopeKey) as HazardReportScope).then(records => {
      if (active) setItems(records);
    }).catch(() => {
      if (active) setError('내 제안을 불러오지 못했습니다. 다시 시도해 주세요.');
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [intake, scopeKey, revision]);
  return <section className="feedback-history" aria-label="내 위험요인 제안">
    <button type="button" className="feedback-refresh" aria-label="내 제안 새로고침" disabled={loading} onClick={() => setRevision(v => v + 1)}><RefreshCw size={18}/></button>
    {loading && <p role="status">불러오는 중</p>}
    {error && <p role="alert">{error}</p>}
    {!loading && !error && !items.length && <p>접수한 제안이 없습니다.</p>}
    {items.map(item => <article key={item.hazardReportId}>
      <span className="feedback-status-dot"/>
      <div><strong>{labels[item.status]} · {item.report.location}</strong>
      <p>{item.report.description}</p>
      <small><time dateTime={item.createdAt}>{new Date(item.createdAt).toLocaleString('ko-KR')}</time></small></div>
    </article>)}
  </section>;
}
